/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MaintenanceRequestHistoryResponse { 
    id: string;
    createdDate: string;
    userName?: string | null;
    status: string;
    comment?: string | null;
}

